<template>
<div class="animated fadeIn">
  <resize-observer @notify="handleResize" />
  <!--[start] Budget Allocation 헤더 -->
  <b-card class="bs-callout bs-callout-primary panelScrollBar" style="height:100px;margin-bottom:12px;">
    <b-row style="min-width: 1200px;">
      <b-col sm="3">
        <div style="margin-top:-7px;">
          <span class="card-title wise-card-header">예산안 최적화</span>
        </div>
        <div class="wise-small-header">Budget Allocation</div>
      </b-col>
      <b-col sm="4" class="brief">
        <div class="wise-small-header">캠페인 타이틀</div>
        <b-form-input class="no-border" :class="{error: errors.has('campaignTitle')}" name="campaignTitle" v-validate="'required|min:2'" v-model="formData.campaignTitle" type="text" placeholder="캠페인 타이틀을 입력하세요"></b-form-input>
      </b-col>
      <b-col sm="2" class="brief" v-if="formData.selectedAllocationMode == 'maxReach'">
        <div class="wise-small-header">총 예산 (백만원)</div>
        <b-form-input class="no-border" :class="{error: errors.has('totalBudget')}" name="totalBudget" v-validate="'required'" min=1 v-model="formData.totalBudgetStr" :formatter="format_budgetStr" type="text"></b-form-input>
      </b-col>
      <b-col sm="2" class="brief" v-else-if="formData.selectedAllocationMode == 'leastBudget'">
        <div class="wise-small-header">목표 도달률 (%)</div>
        <b-form-input class="no-border" min=5 max=90 v-model="formData.goalReach" type="number"></b-form-input>
      </b-col>
      <b-col sm="3" class="brief">
          <b-row>
            <b-col sm="4" class="wise-small-header wise-small-header2" style="padding-top:15px">모드</b-col>
            <b-col sm="5" style="padding-left:0px;padding-right:0px;padding-top:7px">
              <select class="form-control select2 no-border" id="modeOptionSelect">
                <option value="maxReach">최대리치모드</option>
                <option value="leastBudget">최소예산안모드</option>
              </select>
            </b-col>
            <b-col sm="1" style="padding-top:10px">
              <budgetHelpForm01></budgetHelpForm01>
            </b-col>
          </b-row>
      </b-col>
    </b-row>
  </b-card>
  <!--[end] Budget Allocation 헤더 -->
  <!--[start] 캠페인 기본 정보 입력 -->
  <b-card class="bs-callout bs-callout-primary panelScrollBar" style="height:220px;margin-bottom:12px;">
    <div style="min-width: 1200px;">
      <b-row style="padding-bottom:35px;">
        <b-col sm="11" style="height:30px;">
          <span class="card-title wise-card-title">1. 캠페인 기본 정보 입력</span>
          <span class="small text-muted wise-card-subtitle"> 캠페인의 <b>기본정보</b>를 <b>입력</b>하세요.</span>
          <span v-show="showMonthly" class="float-right" style="padding-top:3px;padding-bottom:0px;">
            <c-switch size="lg" type="text" variant="primary-outline-alt" v-model="formData.montlyAllocation"  on="On" off="Off" :checked="false"/>
          </span>
          <span v-show="showMonthly" class="float-right" style="padding-right:10px;padding-top:7px;font-weight:900;">월배분</span>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="1">
        </b-col>
        <b-col sm="4">
          <div class="input-bottom-line">
            <b-row>
              <b-col sm="2" class="wise-small-header wise-small-header2" style="">타이틀</b-col>
              <b-col sm="10" style="padding-left:0px">
                <b-form-input class="no-border" :class="{error: errors.has('simulationTitle')}" name="simulationTitle" v-validate="'required|min:2'" v-model="formData.simulationTitle" type="text" placeholder="시뮬레이션 타이틀을 입력하세요 "></b-form-input>
              </b-col>
            </b-row>
          </div>
        </b-col>
        <b-col sm="2" >
          <div class="input-bottom-line" v-on:click="advertigerModal = true">
            <b-row>
              <b-col sm="4" class="wise-small-header wise-small-header2">광고주</b-col>
              <b-col sm="8" style="padding-left:0px;">
                <input class="form-control no-border" :class="{error: errors.has('advertiger')}" name="advertiger" v-validate="'required|min:2'" v-model="advertigerName" type="text" placeholder="광고주를 선택하세요" v-on:focus="advertigerModal = true"></input>
              </b-col>
            </b-row>
          </div>
        </b-col>
        <b-col sm="2">
          <div class="input-bottom-line" v-on:click="agencyModal = true">
            <b-row>
              <b-col sm="4" class="wise-small-header wise-small-header2">대행사</b-col>
              <b-col sm="8" style="padding-left:0px;">
                <input class="form-control no-border" :class="{error: errors.has('agency')}" name="agency" v-validate="'required|min:2'" v-model="agencyName" type="text" placeholder="대행사를 선택하세요" v-on:focus="agencyModal = true"></input>
              </b-col>
            </b-row>
          </div>
        </b-col>
        <!-- </b-col> -->
      </b-row>
      <b-row style="padding-top:10px">
        <!-- 더 추가 모드선택 / 타겟 설정 / 월 배분 금액1 월 배분 금액2 월 배분 금액3  -->
        <b-col sm="1">
        </b-col>
        <b-col sm="2">
          <div class="input-bottom-line">
            <b-row>
              <b-col sm="4" class="wise-small-header wise-small-header2">업종</b-col>
              <b-col sm="8" style="padding-left:0px;">
                <select id="allocationSelect" class="form-control select2 no-border">
                  <option v-for="(industry_obj, industry) in industryList" :value="JSON.stringify(industry_obj)">{{industry_obj.indt_NM}}</option>
                </select>
              </b-col>
            </b-row>
          </div>
        </b-col>
        <b-col sm="2">
          <div class="input-bottom-line">
            <b-row>
              <b-col sm="3" class="wise-small-header wise-small-header2" style="">타겟</b-col>
              <b-col sm="7" style="padding-left:0px" v-on:click="outputTargetModal = true">
                <b-form-input class="no-border" v-model="formData.genderLabel" type="text" placeholder="타겟선택" v-on:focus="outputTargetModal = true"></b-form-input>
              </b-col>
            </b-row>
          </div>
        </b-col>
        <b-col sm="2" v-if="formData.montlyAllocation" class="animated fadeIn">
          <div class="input-bottom-line">
            <b-row>
              <b-col sm="4" class="wise-small-header wise-small-header2" style="">월배분1</b-col>
              <b-col sm="8" style="padding-left:0px">
                <b-form-input class="no-border" :class="{error: errors.has('monthly1')}" name="monthly1" v-validate="'required|min_value:1'" min=0 max=99 v-model="formData.monthly1" type="number"></b-form-input>
              </b-col>
            </b-row>
          </div>
        </b-col>
        <b-col sm="2" v-if="formData.montlyAllocation" class="animated fadeIn">
          <div class="input-bottom-line">
            <b-row>
              <b-col sm="4" class="wise-small-header wise-small-header2" style="">월배분2</b-col>
              <b-col sm="8" style="padding-left:0px">
                <b-form-input class="no-border" :class="{error: errors.has('monthly2')}" name="monthly2" v-validate="'required|min_value:1'" min=0 max=99 v-model="formData.monthly2" type="number"></b-form-input>
              </b-col>
            </b-row>
          </div>
        </b-col>
        <b-col sm="2" v-if="formData.montlyAllocation" class="animated fadeIn">
          <div class="input-bottom-line">
            <b-row>
              <b-col sm="4" class="wise-small-header wise-small-header2" style="">월배분3</b-col>
              <b-col sm="8" style="padding-left:0px">
                <b-form-input class="no-border" name="monthly3" min=0 max=99 v-model="formData.monthly3" type="number"></b-form-input>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
    </div>
  </b-card>
  <b-modal title="광고주 검색" size="lg" v-model="advertigerModal" @ok="advertigerModal = false">
    <div>
      <b-input-group>
        <input v-model="search_avdt_nm" class="form-control" style="margin-left:5px;" type="text" placeholder="광고주 검색" @keyup.enter="findAdvertiger()"></input>
        <b-input-group-append>
          <b-button style="margin-left:5px;" variant="primary" @click="findAdvertiger()"><i class="fa fa-search"></i> 검색</b-button>
          <b-button style="margin-left:5px;" variant="secondary" @click="advertigerModal = false">취소</b-button>
        </b-input-group-append>
      </b-input-group>
    </div>
    <div class="">
      <br />
      <b>위 검색어에 대한 결과 총 {{advertigerList.length}}건 검색 완료</b>
      <br />
      <br />
    </div>
    <div class="searched-block panelScrollBar" style="overflow-y: auto;overflow-x: hidden;">
      <div style="max-height:200px;">
        <b-button v-for="item in advertigerList" v-bind:key="item.advt_CD" variant="outline-primary" @click="selectedADVT(item)" @keyup.enter="selectedADVT(item)">{{item.advt_NM}}</b-button>
      </div>
    </div>
    <div slot="modal-footer" class="w-100">
      <div class="">
        <br />
        <b>최근 검색된 광고주</b>
        <br />
        <br />
      </div>
      <div class="searched-block">
        <b-button v-for="item in local_advertigerList" v-bind:key="item.advt_CD" variant="outline-success" @click="selectedADVT(item)" @keyup.enter="selectedADVT(item)">{{item.advt_NM}}</b-button>
      </div>
    </div>
  </b-modal>
  <b-modal title="대행사 검색" size="lg" v-model="agencyModal" @ok="agencyModal = false">
    <div>
      <b-input-group>
        <input v-model="search_agc_nm" class="form-control" style="margin-left:5px;" type="text" placeholder="대행사 검색" @keyup.enter="findAgency()"></input>
        <b-input-group-append>
          <b-button style="margin-left:5px;" variant="primary" @click="findAgency()"><i class="fa fa-search"></i> 검색</b-button>
          <b-button style="margin-left:5px;" variant="secondary" @click="agencyModal = false">취소</b-button>
        </b-input-group-append>
      </b-input-group>
    </div>
    <div class="">
      <br />
      <b>위 검색어에 대한 결과 총 {{agencyList.length}}건 검색 완료</b>
      <br />
      <br />
    </div>
    <div class="searched-block panelScrollBar" style="overflow-y: auto;overflow-x: hidden;">
      <div style="max-height:200px;">
        <b-button v-for="item in agencyList" v-bind:key="item.agc_CD" variant="outline-primary" @click="selectedAGC(item)" @keyup.enter="selectedAGC(item)">{{item.agc_NM}}</b-button>
      </div>
    </div>
    <div slot="modal-footer" class="w-100">
      <div class="">
        <br />
        <b>최근 검색된 대행사</b>
        <br />
        <br />
      </div>
      <div class="searched-block">
        <b-button v-for="item in local_agencyList" v-bind:key="item.agc_CD" variant="outline-success" @click="selectedAGC(item)" @keyup.enter="selectedAGC(item)">{{item.agc_NM}}</b-button>
      </div>
    </div>
  </b-modal>
  <!--[start] 매체계획 입력-->
  <b-card style="height:520px" class="bs-callout bs-callout-primary panelScrollBar">
    <div style="min-width: 1200px;">
      <b-row style="padding-bottom:35px;">
        <b-col sm="3" sytle="padding-right:0px;">
          <span class="float-left  card-title wise-card-title">2. 매체 계획(미디어 믹스)입력</span>
          <budgetHelpForm02></budgetHelpForm02>
        </b-col>
        <b-col sm="8">
          <span class="float-right" >
            <b-button block variant="outline-primary" class="btn-pill" @click="addMediaORChannel">
              <span style="font-weight:900;">매체 추가</span>
            </b-button>
          </span>
          <budgetHelpForm05></budgetHelpForm05>
          <span class="float-right" style="padding-top:3px;">
            <c-switch size="lg" type="text" variant="primary-outline-alt"  v-model="formData.allocationPortionON" on="On" off="Off" :checked="true"/>
          </span>
          <span class="float-right" style="padding-right:10px;padding-top:7px;font-weight:900;">할당비율</span>
          <budgetHelpForm04></budgetHelpForm04>
          <span class="float-right mediaOptionSelect">
            <select class="form-control select2" id="mediaOptionSelect">
              <option value="media">미디어-채널 예산안 최적화</option>
              <option value="channel">채널 예산안 최적화</option>
            </select>
          </span>
          <span class="float-right" style="padding-right:10px;padding-top:7px;font-weight:900;">매체기준</span>
          <budgetHelpForm03></budgetHelpForm03>
          <span class="float-right">
            <b-button block variant="outline-success" class="btn-pill" @click="insertBookMark">
              <span style="font-weight:900;">믹스안 저장</span>
            </b-button>
          </span>
        </b-col>
      </b-row>
      <b-row style="padding-bottom:10px; text-align:center;" class="wise-small-header" v-show="formData.selectedMediaOption == 'media'">
        <b-col sm="1">
        </b-col>
        <b-col sm="5">
          <div>
            <b-row>
              <b-col sm="6">미디어</b-col>
              <b-col sm="6">채널</b-col>
            </b-row>
          </div>
        </b-col>
        <b-col sm="2" v-show="formData.allocationPortionON">할당비율 </b-col>
        <b-col sm="2">CPM </b-col>
        <b-col sm="1">
        </b-col>
      </b-row>
      <div class="panelScrollBar" style="overflow-y:auto;overflow-x:hidden;">
        <div style="max-height:380px;" v-show="formData.selectedMediaOption == 'media'">
          <!-- v-bind:key 이거 필요?-->
          <component v-bind:mediaList="formData.mediaList" v-bind:allocationPortionON="formData.allocationPortionON" ref="mediaListRef"
          v-for="item in componentsMediaList"  v-bind:key="item.id" :is="item"></component>
        </div>
      </div>
      <!-- 채널 매체 계획 시작 -->
      <b-row style="padding-bottom:10px; text-align:center;" class="wise-small-header" v-show="formData.selectedMediaOption == 'channel'">
        <b-col sm="1"></b-col>
        <b-col sm="2">
          <br><br>
          <div id="mediaGroupForChannel">
            <p><b-button id="mediaTV" class="btn-pill active" style="width:100px;" variant="outline-success" @click="mediaSelectForChannel('mediaTV');">TV</b-button></p>
            <p><b-button id="mediaPC" class="btn-pill" style="width:100px" variant="outline-success" @click="mediaSelectForChannel('mediaPC');">PC</b-button></p>
            <p><b-button id="mediaMobile" class="btn-pill" style="width:100px" variant="outline-success" @click="mediaSelectForChannel('mediaMobile');">Mobile</b-button></p>
            <p><b-button id="mediaDigital" class="btn-pill" style="width:100px" variant="outline-success" @click="mediaSelectForChannel('mediaDigital');">Digital</b-button></p>
          </div>
        </b-col>
        <b-col sm="9">
          <b-row>
            <b-col sm="3">채널</b-col>
            <b-col sm="3" v-show="formData.allocationPortionON">할당비율 </b-col>
            <b-col sm="2">CPM </b-col>
            <b-col sm="1"></b-col>
          </b-row>
          <div class="panelScrollBar" style="overflow-y:auto;overflow-x:hidden;">
            <div style="max-height:380px;" v-show="formData.selectedMediaOption == 'channel'">
              <!-- v-bind:key 이거 필요?-->
              <component v-bind:mediaList="formData.channelList" v-bind:allocationPortionON="formData.allocationPortionON"
              v-bind:selectedMedia="formData.activeMediaSelectForChannel" ref="channelListRef"
              v-for="item in componentsChannelList" v-bind:key="item.id" :is="item"></component>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
  </b-card>
  <!--[Start] Output 타겟 입력 -->
  <b-modal title="Output 타겟 설정" size="lg" v-model="outputTargetModal" @ok="outputTargetModal = false">
    <reachTarget v-bind:formData="formData" ref="reachTargetRef"></reachTarget>
  </b-modal>
  <!--[End] Output 타겟 입력 -->
  <div style="padding-bottom:20px;">
    <div style="background-color:white; border-left: 2px solid #428bca;">
      <b-button block variant="outline-primary" style="border:1px solid #c2cfd6;border-left:0px;" v-on:click="goResult()">
        <span style="font-weight:900;">GO 예산안 최적화 → </span>
      </b-button>
    </div>
  </div>
  <b-card style="height:110px" class="bs-callout bs-callout-primary panelScrollBar">
    <div style="min-width: 1200px;font-weight:bold">
      * 본 솔루션에서 제공되는 분석결과는 닐슨 3스크린 싱글소스 데이터 및 각 매체사에서 제공되는 실집행 데이터를 기반으로 하며, 매체별 특성을 반영한 평균적인 예측모델을 기준으로 합니다. <br />
      * 즉, 실제 집행과정에서 여러가지 조건들이 전제되는 경우는 본 시스템의 예측영역 밖이며, 이로인해 오차가 크게 발생할 수 있습니다. <br />
      * 또한, 본 시스템의 예측결과는 실제 결과를 보장하지 않으며, 보수적 관점의 예측로직 활용으로 인해 실제 결과보다 낮은 경향의 수치를 제공합니다
    </div>
  </b-card>
</div>
</template>

<script>
// 컴포넌트 / 모듈 / 라이브러리 로드
const moment = require("moment");
import swal from 'sweetalert2'
import select2 from "select2/dist/js/select2.full.min.js";

import Vue from 'vue';
import VueResize from 'vue-resize';
Vue.use(VueResize);
import VeeValidate from 'vee-validate';
Vue.use(VeeValidate);

import MediaTemplate from "./BudgetMediaTemplate";
import ChannelTemplate from "./BudgetChannelTemplate";

import reachFormData from "../common/ReachFormData.js";
import ReachUtils from "../common/ReachUtils.js";
import reachTarget from "../common/reachTarget.vue" // 타겟 컴포넌트
import leftSideUtil from "../common/LeftSideUtil.js" // 타겟 선택 컴포넌트

import cSwitch from '../../components/Switch';
import numeral from 'numeral';

import targetPortionUtils from "../common/targetPortionUtils.js";

import budgetHelpForm01 from "../helpModals/budget/budgetHelpForm01.vue";
import budgetHelpForm02 from "../helpModals/budget/budgetHelpForm02.vue";
import budgetHelpForm03 from "../helpModals/budget/budgetHelpForm03.vue";
import budgetHelpForm04 from "../helpModals/budget/budgetHelpForm04.vue";
import budgetHelpForm05 from "../helpModals/budget/budgetHelpForm05.vue";

export default {
  filters:{
    thousands : function (value) {
      return numeral(value).format('0,0');
    }
  },
  // Date
  components: {
    cSwitch,
    MediaTemplate,
    ChannelTemplate,
    budgetHelpForm01,
    budgetHelpForm02,
    budgetHelpForm03,
    budgetHelpForm04,
    budgetHelpForm05,
    reachTarget
  },
  data() {
    return {
      showMonthly:true,
      hideFooter:true,
      id: '', // 주석 달기
      formData: this.$_.clone(reachFormData.formData),
      historyData : this.$_.clone(reachFormData.historyData),
      advertigerModal: false,
      advertigerName: '',
      agencyModal: false,
      agencyName: '',
      selected_indt: null,
      search_avdt_nm: '',
      advertigerList: [],
      local_advertigerList: [],
      search_agc_nm: '',
      agencyList: [],
      local_agencyList: [],
      industryList: [],
      ////////////////////
      componentsMediaList: [],
      componentsChannelList: [],
      inte_cffcnt :{},
      outputTargetModal: false,
      errorMessage:'',
    }
  },
  created: function() {
    this.id = this._uid + "_";
    this.formData.montlyAllocation = false;
    this.formData.mediaList = new Array(); // 주석달기
    this.formData.channelList = new Array(); // 주석달기

    var formData = this.formData;
  },
  watch:{
    'formData.monthly1':function(){
      if(this.formData.monthly1 > 99){
        this.formData.monthly1 = 99;
      }
    },
    'formData.monthly2':function(){
      if(this.formData.monthly2 > 99){
        this.formData.monthly2 = 99;
      }
    },
    'formData.monthly3':function(){
      if(this.formData.monthly3 > 99){
        this.formData.monthly3 = 99;
      }
    }
  },
  mounted: function() {
    this.$log.debug('Budget.vue mounted 시작');
    leftSideUtil.highLightMenu('budgetCustomId8642');

    this.$http.get('/select/demographics')
      .then((result) => {
        this.$session.set('demographics', result.data);
    })

    this.formData.totalBudget = 5;

    this.$log.debug('Budget.vue mounted 브라우저 쿠키 데이터 로딩 : 기존에 검색했던 광고주 , 대행사');
    this.findIndustry();
    if (localStorage.local_advertigerList == null || localStorage.local_advertigerList == '') {} else {
      this.local_advertigerList = JSON.parse(localStorage.local_advertigerList);
    };
    if (localStorage.local_agencyList == null || localStorage.local_agencyList == '') {} else {
      this.local_agencyList = JSON.parse(localStorage.local_agencyList);
    };
    this.$log.debug('Budget.vue mounted 셀렉트 박스 초기화');
    this.createSelectFn(this);
    this.$log.debug('Budget.vue mounted Inte.계수 로딩');
    this.getInteCffcnt();

    // 항상 가장 마지막에 실행되야함
    var query = this.$route.query.status;
    var historyformData = null;
    if(query != 'new'){ // 타겟관련
      this.$log.debug('Budget.vue [history] 데이터 존재');
      historyformData = this.$session.get('budgetFormData'); // 2018-08-27
    }else{
    }
    if ( historyformData !== null && historyformData !== undefined ){
      // 순서상 채널을위한 미디어선택 버튼의 선택 소스를 먼저 실행해야함.. 위치가 좀 않좋기는 하나...
      this.mediaSelectForChannel(historyformData.activeMediaSelectForChannel);
      this.formData = historyformData;
      this.advertigerName = historyformData.advertiger.advt_NM;
      this.agencyName = historyformData.agency.agc_NM;

      var self = this;
      setTimeout(function(){
        self.$log.debug('Budget.vue [history] 데이터 존재 : 셀렉트 박스 값 지정');
        // 업종선택
        var optionCD = historyformData.industry.indt_CD.substring(4,7);
        optionCD = parseInt(optionCD) - 1;
        var selectOption = '#allocationSelect option:eq(' + optionCD + ')';
        $('#allocationSelect option:eq(0)')[0].selected = false;
        $(selectOption)[0].selected = true;
        // 모드 선택
        if(historyformData.selectedAllocationMode == 'maxReach'){
          $('#modeOptionSelect option:eq(0)')[0].selected = true;
          $('#modeOptionSelect option:eq(1)')[0].selected = false;
        }else if(historyformData.selectedAllocationMode == 'leastBudget'){
          $('#modeOptionSelect option:eq(0)')[0].selected = false;
          $('#modeOptionSelect option:eq(1)')[0].selected = true;
        }
        // 매체기준 선택
        if(historyformData.selectedMediaOption == 'media'){
          $('#mediaOptionSelect option:eq(0)')[0].selected = true;
          $('#mediaOptionSelect option:eq(1)')[0].selected = false;
        }else if(historyformData.selectedMediaOption == 'channel'){
          $('#mediaOptionSelect option:eq(0)')[0].selected = false;
          $('#mediaOptionSelect option:eq(1)')[0].selected = true;
        }
        self.createSelectFn(self);
        self.$refs.reachTargetRef.historyTarget(); // 즐겨찾기 등록된 타겟선택
      }, 1000);

      var mediaListResult = historyformData.mediaListResult;
      if(mediaListResult != null){
        this.$log.debug('Budget.vue [history] 데이터 존재 : mediaListResult 자동 초기화');
        for(var i=0; i<mediaListResult.length; i++){
         this.addMedia();
        }

        var self = this;
        setTimeout(function(){
          var refLen = self.$refs.mediaListRef.length;
          // step1
          for (var i = 0; i < refLen; i++) {
            self.$refs.mediaListRef[i].mediaInfo = mediaListResult[i];
            self.$refs.mediaListRef[i].mediaInfoHistory = self.$_.clone(mediaListResult[i]);
          }
          var keylist = Object.keys(self.formData.mediaList);

          for (var i = 0; i < keylist.length; i++) {
            var key = keylist[i];
            self.formData.mediaList[key] = mediaListResult[i];
          }
        }, 1000);
      }
      //////////////////////////////////////////////////////////////////////////////////////////////
      var channelListResult = historyformData.channelListResult;
      if(channelListResult != null){
        this.$log.debug('Budget.vue [history] 데이터 존재 : channelListResult 자동 초기화');
        for(var i=0; i<channelListResult.length; i++){
         this.addChannel();
        }
        setTimeout(function(){
          var refLen = self.$refs.channelListRef.length;
          // step1
          for (var i = 0; i < refLen; i++) {
            self.$refs.channelListRef[i].mediaInfo = channelListResult[i];
            self.$refs.channelListRef[i].mediaInfoHistory = self.$_.clone(channelListResult[i]);
          }
          var keylist = Object.keys(self.formData.channelList);

          for (var i = 0; i < keylist.length; i++) {
            var key = keylist[i];
            self.formData.channelList[key] = channelListResult[i];
          }
        }, 1000);
      }
    }else{
      this.$refs.reachTargetRef.demographicCount(); // 즐겨찾기에 등록된 타겟이 아닌 신규 타겟
      this.addMedia(); // 뒤로 내린다. else 구문안으로
      this.addMedia(); // 뒤로 내린다. else 구문안으로
      this.addChannel(); // 뒤로 내린다. else 구문안으로
      this.addChannel(); // 뒤로 내린다. else 구문안으로
    }
    if(this.formData.selectedAllocationMode == 'leastBudget'){
      this.showMonthly = false;
      this.formData.montlyAllocation = false;
    }
    this.$log.debug('Budget.vue mounted 종료');
  },
  methods: {
    format_budgetStr(value){
      this.formData.totalBudgetStr = value.replace(/[($)\s\._\-]+/g, '');
      this.formData.totalBudget = numeral(this.formData.totalBudgetStr).format('0');
      return numeral(this.formData.totalBudgetStr).format('0,0');
    },
    dangerModal(message){
      swal({
        type: 'error',
        text: message
      })
    },
    getInteCffcnt(){
      var token = sessionStorage.getItem("myToken");
      this.$http.get('/api/select/allInteCffcntN?access_token='+token)
        .then((result) => {
          var list = result.data;
          for(var i=0; i<list.length; i++){
            this.inte_cffcnt[list[i].int_CFFCNT_CD] = list[i];
          }
          this.$session.set('inte_cffcnt', this.inte_cffcnt);
      });
    },
    mediaSelectForChannel(btnId){
      if(this.formData.activeMediaSelectForChannel != btnId){
        document.getElementById(this.formData.activeMediaSelectForChannel).className
        = document.getElementById(this.formData.activeMediaSelectForChannel).className.replace("active", "");
        this.formData.activeMediaSelectForChannel = btnId;
        document.getElementById(this.formData.activeMediaSelectForChannel).className += " active";
      }
    },
    handleResize() {
      this.createSelectFn(this);
    },
    createSelectFn(vm) {
      $("#allocationSelect").select2({
        theme: "bootstrap",
        placeholder: "업종을 선택하세요",
        "border-color": "red",
      }).on('change', function() {
        vm.$data.formData.industry = JSON.parse(this.value);
      });
      $("#modeOptionSelect").select2({
        theme: "bootstrap",
        "border-color": "red",
        minimumResultsForSearch: -1
      }).on('change', function() {
        vm.$data.formData.selectedAllocationMode = this.value;
        if(this.value == 'maxReach'){
          vm.$data.showMonthly = true;
        }else{
          vm.$data.showMonthly = false;
          vm.formData.montlyAllocation = false;
        }
      });
      $("#mediaOptionSelect").select2({
        theme: "bootstrap",
        "border-color": "red",
        minimumResultsForSearch: -1
      }).on('change', function() {
        vm.$data.formData.selectedMediaOption = this.value;
      });
    }, // end createSelectFn
    findAdvertiger() {
      var param = "?advt_nm=" + this.search_avdt_nm;
      this.$http.get('/select/advertiger' + param)
        .then((result) => {
          this.advertigerList = result.data;
        })
    },
    selectedADVT(advt) {
      this.formData.advertiger = advt;
      this.advertigerName = advt.advt_NM;
      var push = true;
      for (var i = 0; i < this.local_advertigerList.length; i++) {
        if (advt.advt_CD == this.local_advertigerList[i].advt_CD) {
          push = false;
        }
      }
      if (push) {
        this.local_advertigerList.splice(0, 0, advt);
      }
      if (this.local_advertigerList.length > 15) {
        var cnt = this.local_advertigerList.length;
        this.local_advertigerList.splice(15, (cnt - 15));
      }
      localStorage.local_advertigerList = JSON.stringify(this.local_advertigerList);
      this.advertigerModal = false;
    },
    findAgency() {
      var param = "?agc_nm=" + this.search_agc_nm;
      this.$http.get('/select/agency' + param)
        .then((result) => {
          this.agencyList = result.data;
        })
    },
    selectedAGC(agc) {
      this.formData.agency = agc;
      this.agencyName = agc.agc_NM;
      var push = true;
      for (var i = 0; i < this.local_agencyList.length; i++) {
        if (agc.agc_CD == this.local_agencyList[i].agc_CD) {
          push = false;
        }
      }
      if (push) {
        this.local_agencyList.splice(0, 0, agc);
      }
      if (this.local_agencyList.length > 15) {
        var cnt = this.local_agencyList.length;
        this.local_agencyList.splice(15, (cnt - 15));
      }
      localStorage.local_agencyList = JSON.stringify(this.local_agencyList);
      this.agencyModal = false;
    },
    findIndustry() {
      this.$http.get('/select/industry')
        .then((result) => {
          this.industryList = result.data;
          this.formData.industry = this.industryList[0];
        })
    },
    addMediaORChannel(){
      if(this.formData.selectedMediaOption == 'media'){
        this.addMedia();
      }else if(this.formData.selectedMediaOption == 'channel'){
        this.addChannel();
      }
    },
    addMedia() {
      if(Object.keys(this.formData.mediaList).length>8){
      }else{
        this.componentsMediaList.push(this.makeMedia());
      }
    },
    addChannel(){
      if(Object.keys(this.formData.channelList).length>2){
      }else{
        this.componentsChannelList.push(this.makeCahnnel());
      }
    },
    makeMedia() {
      return Vue.component('MediaTemplate', MediaTemplate);
    },
    makeCahnnel(){
      return Vue.component('ChannelTemplate', ChannelTemplate);
    },
    insertBookMark(){
      this.goResult(true);
    },
    goResult(insertBookMark) {
      if(this.formData.selectedMediaOption === 'media'){
        this.goResultMedia(insertBookMark);
      }else if(this.formData.selectedMediaOption === 'channel'){
        this.goResultChannel(insertBookMark);
      }

    },
    goResultMedia(insertBookMark){
      this.$log.debug('goResultMedia 시작');
      var mediaRefLen = this.$refs.mediaListRef.length; // 컴포넌트 리스트 length
      this.$log.debug('goResultMedia 개별 매체안 벨리데이션 시작');
      for (var i = 0; i < mediaRefLen; i++) {
        this.$refs.mediaListRef[i].validationFinish = false;
        this.$refs.mediaListRef[i].validateCheckFN();
      }
      this.$log.debug('goResultMedia 개별 매체안 벨리데이션 종료');

      this.$log.debug('goResultMedia 수작업 벨리데이션 시작');
      var keylist = Object.keys(this.formData.mediaList);
      var validationMediaResultList = {};
      var mediaSize = 0;
      for (var i = 0; i < keylist.length; i++) {
        var key = keylist[i];
        var media1 = this.formData.mediaList[key].media;
        if(validationMediaResultList[media1] != null){
        }else{
          validationMediaResultList[media1] = this.formData.mediaList[key];
          mediaSize += 1;
        }
      }
      if(this.formData.montlyAllocation === true){
        var monthly = parseInt(this.formData.monthly1) + parseInt(this.formData.monthly2);
        if(this.formData.monthly3 > 0 && this.formData.monthly3 < 100){
          monthly += parseInt(this.formData.monthly3);
        }
        if(monthly > 100){
          var errorMessage = '월배분의 총합은 100을 넘을 수 없습니다.'; // 벨리데이션 1
          this.dangerModal(errorMessage);
          return;
        }
      }

      if(mediaSize <2){
        var errorMessage = '두개 이상의 [미디어]를 선택해야 합니다. ex) TV, PC, Mobile, Digital'; // 벨리데이션 1
        this.dangerModal(errorMessage);
        return;
      }

      var keylist = Object.keys(this.formData.mediaList);
      var validationResultList = {};

      var digitalExist = false;
      var pcExist = false;
      var mobileExist = false;
      // var minmumAllocationPortion = 0;
      for (var i = 0; i < keylist.length; i++) {
        var key = keylist[i];
        // minmumAllocationPortion += parseInt(this.formData.mediaList[key].minmumAllocationPortion);

        var media1 = this.formData.mediaList[key].media;
        var channel1 = this.formData.mediaList[key].channel;
        if(validationResultList[media1+channel1] != null){
          var errorMessage = '중복채널 존재 : ' + media1 + ' / ' + channel1; // 벨리데이션
          this.dangerModal(errorMessage);
          return;
        }else{
          validationResultList[media1+channel1] = this.formData.mediaList[key];
        }
        // Digital , PC , Mobile
        if(media1 == 'Digital') digitalExist = true;
        if(media1 == 'PC') pcExist = true;
        if(media1 == 'Mobile') mobileExist = true;

        if(digitalExist&&mobileExist&&pcExist){
          var errorMessage = 'Digital / PC / Mobile매체를 동시에 선택할 수 없습니다. '; // 벨리데이션
          this.dangerModal(errorMessage);
          return;
        }
        if(digitalExist&&pcExist){
          var errorMessage = 'Digital / PC매체를 동시에 선택할 수 없습니다. '; // 벨리데이션
          this.dangerModal(errorMessage);
          return;
        }
        if(digitalExist&&mobileExist){
          var errorMessage = 'Digital / Mobile매체를 동시에 선택할 수 없습니다. '; // 벨리데이션
          this.dangerModal(errorMessage);
          return;
        }
      }
      // if(this.formData.allocationPortionON === true){
      //   if(minmumAllocationPortion > 100){
      //     var errorMessage = '할당비율의 총합은 100을 넘을 수 없습니다.'; // 벨리데이션
      //     this.dangerModal(errorMessage);
      //     return;
      //   }
      // }
      this.$log.debug('goResultMedia 수작업 벨리데이션 종료');
      this.$log.debug('goResultMedia 본화면 벨리데이션 시작');
      this.$validator.validateAll().then(res => {
        if (res) {
          var mediaList = [];
          var finalResult = true;
          var keylist = Object.keys(this.formData.mediaList);

          var self = this;
          var cnt = 0;
          clearInterval(this.resultInterval);
          var resultInterval = this.resultInterval;

          resultInterval = setInterval(function() {
            for (var i = 0; i < keylist.length; i++) {
              var key = keylist[i];
              finalResult = finalResult && self.formData.mediaList[key].formValidation; // 모든 개별 매체안의 벨리데이션이 True 인지 확인
              mediaList.push(self.formData.mediaList[key]);
            }
            self.formData.mediaListResult = mediaList;
            if (finalResult) { // 모든 개별 매체안의 벨리데이션이 True인 경우
              self.$log.debug('goResultMedia 모든 벨리데이션 성공');
              clearInterval(resultInterval); // 여기 까지 왔으면 더이상 반복할 필요 없으므로 clear
              for(var i=0; i<self.formData.mediaListResult.length; i++){ // OutPut타겟을 Input타겟으로 주입 (Input타겟 선택이 없었음)
                self.formData.mediaListResult[i].vehicle='전체';
                self.formData.mediaListResult[i].target = self.formData.targetCode;
                self.formData.mediaListResult[i].target_cnt = self.formData.demographic_cnt;
              }
              var token = sessionStorage.getItem("myToken");
              var param = encodeURI(JSON.stringify(self.formData.mediaListResult));

              var data = new FormData();
              data.append('objs', param);
              var config = {
                onUploadProgress: function(progressEvent) {
                  var percentCompleted = Math.round( (progressEvent.loaded * 100) / progressEvent.total );
                }
              };

              self.$http.post('/api/select/cffcntBetaRegression?access_token='+token, data, config)
                .then((result) => {
                  for(var i=0; i<self.formData.mediaListResult.length; i++){
                    self.formData.mediaListResult[i].a  = result.data[i].a;
                    self.formData.mediaListResult[i].b1 = result.data[i].b1;
                    self.formData.mediaListResult[i].b2 = result.data[i].b2;
                    self.formData.mediaListResult[i].b3 = result.data[i].b3;
                    self.formData.mediaListResult[i].lmt = result.data[i].lmt;

                    self.formData.mediaListResult[i].cpm = parseInt(self.formData.mediaListResult[i].cpm);
                  }
                  if(insertBookMark){ // 북마킹인 경우
                    self.$log.debug('goResultMedia 북마킹 시작');
                    self.insertHistoryData();
                    swal({
                      position: 'top-end',
                      type: 'success',
                      title: '믹스안을 저장하였습니다.',
                      showConfirmButton: false,
                      timer: 1500
                    })
                    setTimeout(function(){
                      sessionStorage.setItem("bookMarkReload", "insert");
                    }, 500);
                    self.$log.debug('goResultMedia 북마킹 종료');
                  }else{ // 결과 화면으로 넘어가는 로직
                    //////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    self.$log.debug('goResultMedia 타겟 배분비율 적용 전처리 시작');
                    var ageCntList = new Map();
                    targetPortionUtils.getSplit5AgeList(ageCntList);
                    var portionList = new Map();
                    targetPortionUtils.getTargetPortionList(portionList);
                    // 아웃풋 타겟 쪽 배분비율 계산
                    var outputAge = self.formData.age;
                    var outputGender = self.formData.gender;
                    var outputAgeCode = ageCntList.get(outputAge);
                    self.formData.outputAgeCode = outputAgeCode;
                    self.$log.debug('[타겟 배분비율 로직] 아웃풋타겟 : ', outputGender, outputAge);
                    self.$log.debug('[타겟 배분비율 로직] 아웃풋타겟 : ', self.formData.outputAgeCode);
                    for(var i=0; i<self.formData.mediaListResult.length; i++){ // TV, SMR 은 전체 타겟으로 변경
                      if(self.formData.mediaListResult[i].media == "TV" || self.formData.mediaListResult[i].channel == "SMR" ){
                        self.formData.mediaListResult[i].age = '769';
                        self.formData.mediaListResult[i].gender = 'MF';
                      }else{
                        self.formData.mediaListResult[i].age = self.formData.age;
                        self.formData.mediaListResult[i].gender = self.formData.gender;
                      }
                      // self.$log.debug(self.formData.mediaListResult[i]);
                      // GRPs = (E.Imp / 타겟모수) * 100
                      var inputAge = self.formData.mediaListResult[i].age;
                      self.formData.mediaListResult[i].inputAgeCode = ageCntList.get(inputAge);

                      var inputGender = self.formData.mediaListResult[i].gender;
                      var channel = self.formData.mediaListResult[i].channel;
                      // Facebook, Youtube, SMR 이 아닌경우는 미디어 배분비율로 변경
                      if(channel != 'Facebook' && channel != 'Youtube' && channel != 'SMR' ){
                        channel = self.formData.mediaListResult[i].media;
                      }
                      var channelGender = channel + '_' + inputGender;
                      var inputPortionList = portionList.get(channelGender);
                      var portionSum = 0.00;

                      var inputAgeCode = self.formData.mediaListResult[i].inputAgeCode;
                      var intersectedCode = [];
                      for(var j=0; j< inputAgeCode.length; j++){
                        if(inputAgeCode[j] == 1){
                          portionSum += inputPortionList[j].portion;
                        }
                        if(inputAgeCode[j]&&outputAgeCode[j]){
                          intersectedCode[j] = 1;
                        }else{
                          intersectedCode[j] = 0;
                        }
                      }
                      self.formData.mediaListResult[i].portionSum = portionSum; // input타겟 배분비율 총합 계산
                      self.formData.mediaListResult[i].intersectedCode = intersectedCode; // input타겟과 output타겟의 교차점 계산
                      self.$log.debug('[타겟 배분비율 로직] 인풋타겟 : ', channelGender, inputAge);
                    }
                    self.$log.debug('goResultMedia 타겟 배분비율 적용 전처리 종료');
                    //////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    self.$session.set('budgetMediaInputFormData', self.formData);
                    self.$session.set('budgetFormData', self.formData); // 2018.11.20

                    if(self.formData.selectedAllocationMode == 'maxReach'){
                      window.location.href = "#/budget/mediaBudgetResult";
                    }else if(self.formData.selectedAllocationMode == 'leastBudget'){
                      window.location.href = "#/budget/mediaReachResult";
                    }
                  }
                });
            }
            cnt++;
            clearInterval(resultInterval);
          }, 1000);
          this.resultInterval = resultInterval; // 아직 진행중인데 다시 goResult를 누를 수 있으므로.
        } else {
          // 아래의 코드들은 별로 유의미해 보이지는 않는데 ... 에러 발생했을때 체크 하는 코드
          var keylist = Object.keys(this.formData.mediaList);
          for (var i = 0; i < keylist.length; i++) {
            var key = keylist[i];
            // console.log(this.formData.mediaList[key]);
          }
        }
      })
      this.$log.debug('goResultMedia 본화면 벨리데이션 종료');
      this.$log.debug('goResultMedia 종료');
    },
    goResultChannel(insertBookMark){
      this.$log.debug('goResultChannel 시작');
      var channelRefLen = this.$refs.channelListRef.length;
      var channelLen = Object.keys(this.formData.channelList).length;
      this.$log.debug('goResultChannel 개별 매체안 벨리데이션 시작');
      for (var i = 0; i < channelRefLen; i++) {
        this.$refs.channelListRef[i].validationFinish = false;
        this.$refs.channelListRef[i].validateCheckFN();
      }
      this.$log.debug('goResultChannel 수작업 벨리데이션 시작');
      if(this.formData.montlyAllocation === true){
        var monthly = parseInt(this.formData.monthly1) + parseInt(this.formData.monthly2);
        if(this.formData.monthly3 > 0 && this.formData.monthly3 < 100){
          monthly += parseInt(this.formData.monthly3);
        }
        if(monthly > 100){
          var errorMessage = '월배분의 총합은 100을 넘을 수 없습니다.'; // 벨리데이션 1
          this.dangerModal(errorMessage);
          return;
        }
      }

      if(channelLen < 2){ // 추가 폼벨리데이션 로직
        var errorMessage = '두개 이상의 채널을 선택하여야 합니다.';
        this.dangerModal(errorMessage);
        // alert('두개 이상의 채널을 선택하여야 합니다.'); // error message
        return;
      }
      var keylist = Object.keys(this.formData.channelList);
      var validationResultList = {};
      // var minmumAllocationPortion = 0;
      for (var i = 0; i < keylist.length; i++) {
        var key = keylist[i];
        // minmumAllocationPortion += parseInt(this.formData.channelList[key].minmumAllocationPortion);
        var channel1 = this.formData.channelList[key].channel;
        if(validationResultList[channel1] != null){
          var errorMessage = '중복채널 존재 : ' + channel1;
          this.dangerModal(errorMessage);
          return;
        }else{
          validationResultList[channel1] = this.formData.channelList[key];
        }
      }
      // if(this.formData.allocationPortionON === true){
      //   if(minmumAllocationPortion > 100){
      //     var errorMessage = '할당비율의 총합은 100을 넘을 수 없습니다.'; // 벨리데이션2
      //     this.dangerModal(errorMessage);
      //     return;
      //   }
      // }
      this.$log.debug('goResultChannel 수작업 벨리데이션 종료');
      this.$log.debug('goResultChannel 본화면 벨리데이션 시작');
      // step3
      this.$validator.validateAll().then(res => {
        if (res) {
          var channelList = [];
          var finalResult = true;
          var keylist = Object.keys(this.formData.channelList);
          var self = this;
          var cnt = 0;
          clearInterval(this.resultInterval);
          var resultInterval = this.resultInterval;

          resultInterval = setInterval(function() {
            for (var i = 0; i < keylist.length; i++) {
              var key = keylist[i];
              finalResult = finalResult && self.formData.channelList[key].formValidation; // 모든 개별 매체안의 벨리데이션이 True 인지 확인
              channelList.push(self.formData.channelList[key]);
            }
            self.formData.channelListResult = channelList;
            if (finalResult) { // 모든 개별 매체안의 벨리데이션이 True인 경우
              self.$log.debug('goResultChannel 모든 벨리데이션 성공');
              clearInterval(resultInterval); // 여기 까지 왔으면 더이상 반복할 필요 없으므로 clear
              for(var i=0; i<self.formData.channelListResult.length; i++){
                self.formData.channelListResult[i].vehicle='전체';
                self.formData.channelListResult[i].target = self.formData.targetCode;
                self.formData.channelListResult[i].target_cnt = self.formData.demographic_cnt;
              }
              var token = sessionStorage.getItem("myToken");
              var param = encodeURI(JSON.stringify(self.formData.channelListResult));

              var data = new FormData();
              data.append('objs', param);
              var config = {
                onUploadProgress: function(progressEvent) {
                  var percentCompleted = Math.round( (progressEvent.loaded * 100) / progressEvent.total );
                }
              };

              self.$http.post('/api/select/cffcntBetaRegression?access_token='+token, data, config)
                .then((result) => {

                  for(var i=0; i<self.formData.channelListResult.length; i++){
                    self.formData.channelListResult[i].a  = result.data[i].a;
                    self.formData.channelListResult[i].b1 = result.data[i].b1;
                    self.formData.channelListResult[i].b2 = result.data[i].b2;
                    self.formData.channelListResult[i].b3 = result.data[i].b3;
                    self.formData.channelListResult[i].lmt = result.data[i].lmt;
                    self.formData.channelListResult[i].cpm = parseInt(self.formData.channelListResult[i].cpm);
                  }
                  if(insertBookMark){ // 북마킹인 경우
                    self.insertHistoryData();
                    swal({
                      position: 'top-end',
                      type: 'success',
                      title: '믹스안을 저장하였습니다.',
                      showConfirmButton: false,
                      timer: 1500
                    })
                    setTimeout(function(){
                      sessionStorage.setItem("bookMarkReload", "insert");
                    }, 500);
                  }else{ // 북마킹이 아니고 결과 화면으로 넘어가는 로직
                    //////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    self.$log.debug('goResultChannel 타겟 배분비율 적용 전처리 시작');
                    var ageCntList = new Map();
                    targetPortionUtils.getSplit5AgeList(ageCntList);
                    var portionList = new Map();
                    targetPortionUtils.getTargetPortionList(portionList);
                    // 아웃풋 타겟 쪽 배분비율 계산
                    var outputAge = self.formData.age;
                    var outputGender = self.formData.gender;
                    var outputAgeCode = ageCntList.get(outputAge);
                    self.formData.outputAgeCode = outputAgeCode;
                    self.$log.debug('[타겟 배분비율 로직] 아웃풋타겟 : ', outputGender, outputAge);
                    for(var i=0; i<self.formData.channelListResult.length; i++){

                      if(self.formData.channelListResult[i].media == "TV" || self.formData.channelListResult[i].channel == "SMR" ){
                        self.formData.channelListResult[i].age = '769';
                        self.formData.channelListResult[i].gender = 'MF';
                      }else{
                        self.formData.channelListResult[i].age = self.formData.age;
                        self.formData.channelListResult[i].gender = self.formData.gender;
                      }
                      // GRPs = (E.Imp / 타겟모수) * 100
                      // self.$log.debug(self.formData.channelListResult[i]);
                      var inputAge = self.formData.channelListResult[i].age;
                      self.formData.channelListResult[i].inputAgeCode = ageCntList.get(inputAge);

                      var inputGender = self.formData.channelListResult[i].gender;
                      var channel = self.formData.channelListResult[i].channel;
                      if(channel != 'Facebook' && channel != 'Youtube' && channel != 'SMR' ){
                        channel = self.formData.channelListResult[i].media;
                      }
                      var channelGender = channel + '_' + inputGender;

                      var inputPortionList = portionList.get(channelGender);
                      var portionSum = 0.00;

                      var inputAgeCode = self.formData.channelListResult[i].inputAgeCode;
                      var intersectedCode = [];
                      for(var j=0; j< inputAgeCode.length; j++){
                        if(inputAgeCode[j] == 1){
                          portionSum += inputPortionList[j].portion;
                        }
                        if(inputAgeCode[j]&&outputAgeCode[j]){
                          intersectedCode[j] = 1;
                        }else{
                          intersectedCode[j] = 0;
                        }
                      }
                      self.formData.channelListResult[i].portionSum = portionSum;
                      self.formData.channelListResult[i].intersectedCode = intersectedCode;
                      self.$log.debug('[타겟 배분비율 로직] 인풋타겟 : ', channelGender, inputAge);
                      self.$log.debug('[타겟 배분비율 로직] 인풋타겟 : ', self.formData.channelListResult[i].inputAgeCode);
                    }
                    self.$log.debug('goResultChannel 타겟 배분비율 적용 전처리 종료');
                    //////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    self.$session.set('budgetChannelInputFormData', self.formData);
                    self.$session.set('budgetFormData', self.formData); // 2018.11.20
                    if(self.formData.selectedAllocationMode == 'maxReach'){
                      window.location.href = "#/budget/channelBudgetResult";
                    }else if(self.formData.selectedAllocationMode == 'leastBudget'){
                      window.location.href = "#/budget/channelReachResult";
                    }
                  }
                });
            }
            cnt++;
            clearInterval(resultInterval);
          }, 1000);

          this.resultInterval = resultInterval;

        } else {
          var keylist = Object.keys(this.formData.channelList);
          for (var i = 0; i < keylist.length; i++) {
            var key = keylist[i];

          }
        }
      })
      this.$log.debug('goResultChannel 본화면 벨리데이션 종료');
      this.$log.debug('goResultChannel 종료');
    },
    changeBudget(value) {

      this.mediaBudgetSum = 0;
      var keylist = Object.keys(this.formData.mediaList);
      for (var i = 0; i < keylist.length; i++) {
        var key = keylist[i];
        this.mediaBudgetSum += parseInt(this.formData.mediaList[key].budget);
      }
    },
    insertHistoryData() {

      this.historyData.user_id = this.$session.get('email');
      this.historyData.std_dt = moment().format('YYYY-MM-DD HH:mm');
      this.historyData.view_cd = 'budgetAllocation';
      this.historyData.view_name = '예산안최적화';
      this.historyData.formData = JSON.stringify(this.formData);
      this.historyData.css = "warning";
      var token = sessionStorage.getItem("myToken");
      var param = encodeURI(JSON.stringify(this.historyData));

      var data = new FormData();
      data.append('objs', param);
      var config = {
        onUploadProgress: function(progressEvent) {
          var percentCompleted = Math.round( (progressEvent.loaded * 100) / progressEvent.total );
        }
      };

      this.$http.post('/api/insert/history?access_token='+token, data,config)
        .then((result) => {

        })
    },
  }
}
</script>
<style src="select2/dist/css/select2.min.css"></style>
<style src="select2-bootstrap-theme/dist/select2-bootstrap.min.css"></style>

<style scoped>
#mediaGroupForChannel .btn.active {
  color: #fff;
  border: 1px solid #428bca !important;
}
#genderGroup .btn.active {
  color: #fff;
  border: 1px solid #428bca !important;
}

#ageGroup .btn.active {
  color: #fff;
  border: 1px solid #049372 !important;
}

.btn-age-group-lg {
  width: 234px;
  margin-right: 11px;
  font-weight: 600;
}

.btn-age-group-sm {
  width: 65px;
  margin-right: 5px;
  margin-bottom: 3px;
  font-weight: 600;
}
</style>

<style>
select.error+.select2-container--bootstrap .select2-selection--single {
  color: #9F3A38 !important;
  background-color: #FFF6F6 !important;
  border-color: #E0B4B4 !important;
}

input.error {
  color: #9F3A38 !important;
  background-color: #FFF6F6 !important;
  border-color: #E0B4B4;
}
.mediaOptionSelect  .select2-container--bootstrap .select2-selection--single {
  border-color: #20a8d8 !important;
  box-shadow: inset 0 0 0 rgba(0,0,0,0) !important;
  font-weight: 600 !important;
}

.mediaOptionSelect .select2-container--bootstrap .select2-selection--single .select2-selection__rendered {
  color:#20a8d8;
}
</style>



// WEBPACK FOOTER //
// src/views/budget/Budget.vue